import { type useAllGroups } from 'app/network/groups';
import { type useMyActivePlans } from 'app/network/plan';
import { createTheme as createDSTheme } from 'app/shopify';

export const theme = createDSTheme();

export type ActivePlan = NonNullable<ReturnType<typeof useMyActivePlans>['data']>[number];

export type UserGroup = NonNullable<ReturnType<typeof useAllGroups>['data']>[number];
